import React from "react"
import { Modal, Button, FormGroup, Form, ControlLabel, FormControl } from "react-bootstrap"

import * as locationService from "../../../services/location-service"

import { handleKeyPress } from '../../../utils'

export default class LocationModal extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handlePost = this.handlePost.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)

    this.state = {
      location: {},
      message: ''
    }
  }

  handleShow() {
    if (this.props.id) {
      locationService.getLocationById(this.props.id).then(location => {
        this.setState({
          location: location,
          show: true 
        })
      })
    } else {
      this.setState({show: true})
    }
  }

  handleHide() {
    this.setState({ show: false, location: {} })
  }

  handlePost() {
    if (this.validate()) {
      const location = this.state.location
      locationService
        .upsertLocation(location).then(() => {
          this.handleHide()
          this.props.reload()
          this.setState({message: ''})
        }).catch(error => {this.setState({message: 'Opslaan mislukt. Mogelijk bestaat deze locatie al.'})})
    }
  }

  handleNameChange(e) {
    let location = this.state.location
    location.name = e.target.value
    this.setState({ location: location })
  }

  validate() {
    const { location } = this.state
    return location.name && location.name.length > 0
  }

  render() {
    const { location, message} = this.state
    const { title, textbt, modalbttext } = this.props

    return (
      <div>
        <Button
          bsStyle="primary"
          className="edit-entry action-btn"
          onClick={this.handleShow}
        >
          {textbt}
        </Button>

        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          onKeyPress={(e) => handleKeyPress(e, this.handlePost)}
          dialogClassName="custom-modal modal-new-location"
          backdrop={false}>

          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {title}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {message && <div className='error'>{message}</div>}
            <p>Wilt u een locatie toevoegen?</p>
            
            <Form>
              <FormGroup controlId="unit">
                <ControlLabel>Naam locatie *</ControlLabel>{' '}
                <FormControl onChange={this.handleNameChange} type="text" value={location && location.name} />
              </FormGroup>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handlePost} disabled={!this.validate()}>
              {modalbttext}
            </Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Locations/modal/LocationModal.js